import { render } from "./dropdown-menu.html?vue&type=template&id=0c4f1614&ts=true&external"
import script from "./dropdown-menu.ts?vue&type=script&lang=ts&external"
export * from "./dropdown-menu.ts?vue&type=script&lang=ts&external"

import "./dropdown-menu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__